var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackPayments(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156_29008",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#1C1B1F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156_29008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25033 28.3327C3.47116 28.3327 2.80414 28.0553 2.24928 27.5004C1.69442 26.9455 1.41699 26.2785 1.41699 25.4993V9.91602H4.25033V25.4993H28.3337V28.3327H4.25033ZM9.91699 22.666C9.13783 22.666 8.47081 22.3886 7.91595 21.8337C7.36109 21.2789 7.08366 20.6118 7.08366 19.8327V8.49935C7.08366 7.72018 7.36109 7.05317 7.91595 6.49831C8.47081 5.94345 9.13783 5.66602 9.91699 5.66602H29.7503C30.5295 5.66602 31.1965 5.94345 31.7514 6.49831C32.3062 7.05317 32.5837 7.72018 32.5837 8.49935V19.8327C32.5837 20.6118 32.3062 21.2789 31.7514 21.8337C31.1965 22.3886 30.5295 22.666 29.7503 22.666H9.91699ZM12.7503 19.8327C12.7503 19.0535 12.4729 18.3865 11.918 17.8316C11.3632 17.2768 10.6962 16.9993 9.91699 16.9993V19.8327H12.7503ZM26.917 19.8327H29.7503V16.9993C28.9712 16.9993 28.3041 17.2768 27.7493 17.8316C27.1944 18.3865 26.917 19.0535 26.917 19.8327ZM19.8337 18.416C21.0142 18.416 22.0177 18.0028 22.8441 17.1764C23.6705 16.35 24.0837 15.3466 24.0837 14.166C24.0837 12.9855 23.6705 11.982 22.8441 11.1556C22.0177 10.3292 21.0142 9.91602 19.8337 9.91602C18.6531 9.91602 17.6496 10.3292 16.8232 11.1556C15.9969 11.982 15.5837 12.9855 15.5837 14.166C15.5837 15.3466 15.9969 16.35 16.8232 17.1764C17.6496 18.0028 18.6531 18.416 19.8337 18.416ZM9.91699 11.3327C10.6962 11.3327 11.3632 11.0553 11.918 10.5004C12.4729 9.94553 12.7503 9.27852 12.7503 8.49935H9.91699V11.3327ZM29.7503 11.3327V8.49935H26.917C26.917 9.27852 27.1944 9.94553 27.7493 10.5004C28.3041 11.0553 28.9712 11.3327 29.7503 11.3327Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPayments);
export default __webpack_public_path__ + "static/media/black_payments.c1c7f5fbe3f6f76430d3a73e37e6bfdf.svg";
export { ForwardRef as ReactComponent };